/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type DepartmentCountFilterType = 'ALL' | 'NONE' | 'ONE' | 'MORE';

export const DepartmentCountFilterType = {
    ALL: 'ALL' as DepartmentCountFilterType,
    NONE: 'NONE' as DepartmentCountFilterType,
    ONE: 'ONE' as DepartmentCountFilterType,
    MORE: 'MORE' as DepartmentCountFilterType
};

